import {
  AnswerResponseProgress,
  CmmcLevel,
  CompanyFeatureFlag,
  CompanyType,
  CriteriaOperator,
  CriteriaType,
  ExpertNoteIdentifier,
  FieldedStatus,
  LlmLogType,
  ResearchOrganizationType,
  TechnologyType,
  VerificationConfidence,
} from '@@types/api.types';
import { COMPANY_TYPE_LABELS } from '@utils/company.util';

export const defaultErrorMessage = 'Something went wrong';

export const countries = [
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Albania', code: 'AL' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'Andorra', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Brazil', code: 'BR' },
  { name: 'Brunei', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cabo Verde', code: 'CV' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Canada', code: 'CA' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo, Democratic Republic of the', code: 'CD' },
  { name: 'Congo, Republic of the', code: 'CG' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Cuba', code: 'CU' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egypt', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Eswatini', code: 'SZ' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Germany', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Greece', code: 'GR' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'India', code: 'IN' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Iran', code: 'IR' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  { name: 'Korea, North', code: 'KP' },
  { name: 'Korea, South', code: 'KR' },
  { name: 'Kosovo', code: 'XK' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: 'Laos', code: 'LA' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libya', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mali', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Micronesia', code: 'FM' },
  { name: 'Moldova', code: 'MD' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montenegro', code: 'ME' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Myanmar', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'North Macedonia', code: 'MK' },
  { name: 'Norway', code: 'NO' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Palestine', code: 'PS' },
  { name: 'Panama', code: 'PA' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Romania', code: 'RO' },
  { name: 'Russia', code: 'RU' },
  { name: 'Rwanda', code: 'RW' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Samoa', code: 'WS' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sao Tome and Principe', code: 'ST' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia', code: 'RS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Somalia', code: 'SO' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'South Sudan', code: 'SS' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Sudan', code: 'SD' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Syria', code: 'SY' },
  { name: 'Taiwan', code: 'TW' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Tanzania', code: 'TZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Timor-Leste', code: 'TL' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States', code: 'US' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Vatican City', code: 'VA' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Vietnam', code: 'VN' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZW' },
];

// Countries with military services
export const MILITARY_SERVICE_COUNTRY_CODES = ['AU', 'GB', 'US'] as const;

export const MILITARY_SERVICE_CODE_TO_COUNTRY: Record<string, string> = {
  AU: 'Australia',
  GB: 'United Kingdom',
  US: 'United States',
};

export const MILITARY_SERVICE_COUNTRY_TO_CODE: Record<string, string> = {
  Australia: 'AU',
  'United Kingdom': 'GB',
  'United States': 'US',
};

export const usStates = [
  { name: 'Alabama', code: 'AL' },
  { name: 'Alaska', code: 'AK' },
  { name: 'Arizona', code: 'AZ' },
  { name: 'Arkansas', code: 'AR' },
  { name: 'California', code: 'CA' },
  { name: 'Colorado', code: 'CO' },
  { name: 'Connecticut', code: 'CT' },
  { name: 'Delaware', code: 'DE' },
  { name: 'Florida', code: 'FL' },
  { name: 'Georgia', code: 'GA' },
  { name: 'Hawaii', code: 'HI' },
  { name: 'Idaho', code: 'ID' },
  { name: 'Illinois', code: 'IL' },
  { name: 'Indiana', code: 'IN' },
  { name: 'Iowa', code: 'IA' },
  { name: 'Kansas', code: 'KS' },
  { name: 'Kentucky', code: 'KY' },
  { name: 'Louisiana', code: 'LA' },
  { name: 'Maine', code: 'ME' },
  { name: 'Maryland', code: 'MD' },
  { name: 'Massachusetts', code: 'MA' },
  { name: 'Michigan', code: 'MI' },
  { name: 'Minnesota', code: 'MN' },
  { name: 'Mississippi', code: 'MS' },
  { name: 'Missouri', code: 'MO' },
  { name: 'Montana', code: 'MT' },
  { name: 'Nebraska', code: 'NE' },
  { name: 'Nevada', code: 'NV' },
  { name: 'New Hampshire', code: 'NH' },
  { name: 'New Jersey', code: 'NJ' },
  { name: 'New Mexico', code: 'NM' },
  { name: 'New York', code: 'NY' },
  { name: 'North Carolina', code: 'NC' },
  { name: 'North Dakota', code: 'ND' },
  { name: 'Ohio', code: 'OH' },
  { name: 'Oklahoma', code: 'OK' },
  { name: 'Oregon', code: 'OR' },
  { name: 'Pennsylvania', code: 'PA' },
  { name: 'Rhode Island', code: 'RI' },
  { name: 'South Carolina', code: 'SC' },
  { name: 'South Dakota', code: 'SD' },
  { name: 'Tennessee', code: 'TN' },
  { name: 'Texas', code: 'TX' },
  { name: 'Utah', code: 'UT' },
  { name: 'Vermont', code: 'VT' },
  { name: 'Virginia', code: 'VA' },
  { name: 'Washington', code: 'WA' },
  { name: 'West Virginia', code: 'WV' },
  { name: 'Wisconsin', code: 'WI' },
  { name: 'Wyoming', code: 'WY' },
];

export const countryPhoneCodes = [
  '+93',
  '+355',
  '+213',
  '+376',
  '+244',
  '+1-268',
  '+54',
  '+374',
  '+61',
  '+43',
  '+994',
  '+1-242',
  '+973',
  '+880',
  '+1-246',
  '+375',
  '+32',
  '+501',
  '+229',
  '+975',
  '+591',
  '+387',
  '+267',
  '+55',
  '+673',
  '+359',
  '+226',
  '+257',
  '+238',
  '+855',
  '+237',
  '+1',
  '+236',
  '+235',
  '+56',
  '+86',
  '+57',
  '+269',
  '+243',
  '+242',
  '+506',
  '+385',
  '+53',
  '+357',
  '+420',
  '+45',
  '+253',
  '+1-767',
  '+1-809',
  '+593',
  '+20',
  '+503',
  '+240',
  '+291',
  '+372',
  '+268',
  '+251',
  '+679',
  '+358',
  '+33',
  '+241',
  '+220',
  '+995',
  '+49',
  '+233',
  '+30',
  '+1-473',
  '+502',
  '+224',
  '+245',
  '+592',
  '+509',
  '+504',
  '+36',
  '+354',
  '+91',
  '+62',
  '+98',
  '+964',
  '+353',
  '+972',
  '+39',
  '+1-876',
  '+81',
  '+962',
  '+7',
  '+254',
  '+686',
  '+850',
  '+82',
  '+383',
  '+965',
  '+996',
  '+856',
  '+371',
  '+961',
  '+266',
  '+231',
  '+218',
  '+423',
  '+370',
  '+352',
  '+261',
  '+265',
  '+60',
  '+960',
  '+223',
  '+356',
  '+692',
  '+222',
  '+230',
  '+52',
  '+691',
  '+373',
  '+377',
  '+976',
  '+382',
  '+212',
  '+258',
  '+95',
  '+264',
  '+674',
  '+977',
  '+31',
  '+64',
  '+505',
  '+227',
  '+234',
  '+389',
  '+47',
  '+968',
  '+92',
  '+680',
  '+970',
  '+507',
  '+675',
  '+595',
  '+51',
  '+63',
  '+48',
  '+351',
  '+974',
  '+40',
  '+250',
  '+1-869',
  '+1-758',
  '+1-784',
  '+685',
  '+378',
  '+239',
  '+966',
  '+221',
  '+381',
  '+248',
  '+232',
  '+65',
  '+421',
  '+386',
  '+677',
  '+252',
  '+27',
  '+211',
  '+34',
  '+94',
  '+249',
  '+597',
  '+46',
  '+41',
  '+963',
  '+886',
  '+992',
  '+255',
  '+66',
  '+670',
  '+228',
  '+676',
  '+1-868',
  '+216',
  '+90',
  '+993',
  '+688',
  '+256',
  '+380',
  '+971',
  '+44',
  '+598',
  '+998',
  '+678',
  '+379',
  '+58',
  '+84',
  '+967',
  '+260',
  '+263',
];

export const DEFAULT_COUNTRY = 'US';

export const DEFAULT_COUNTRY_CODE = '+1';

export const SURVEY_CONFIRM_DELETE_COMPLETION_PERCENTAGE_THRESHOLD = 0.3;

export const SUPPORT_EMAIL = 'support@azymmetric.com';

export const PHASES_OF_OPERATIONS_LABELS = [
  'Shape',
  'Deter',
  'Seize Initiative',
  'Dominate',
  'Stabilize',
  'Enable Civil Authority',
];

export const EXPERT_NOTE_TITLES: Record<ExpertNoteIdentifier, string> = {
  THREATS: 'Threats and Responses',
  STRATEGIC: 'Strategic/Operational',
  RISKS: 'Risks & Issues',
  SUSTAINMENT: 'Sustainment Considerations',
} as const;

/**
 * MRL and TRL settings for the score component.
 * These are used to display the information in the tooltip content.
 *
 */
export const MRL_TRL_SETTINGS = {
  trl: {
    levels: [
      {
        level: 1,
        label: 'Basic Principles Identified',
        description:
          'Foundational concepts are established. Early documentation or academic work identifies core scientific or architectural principles, but no validation or prototyping has begun.',
      },
      {
        level: 2,
        label: 'Feasibility and Applications',
        description:
          'Feasibility studies are conducted, expert opinions gathered, and possible applications explored. Early simulations or modeling may be initiated.',
      },
      {
        level: 3,
        label: 'Proof of Concept',
        description:
          'First experimental validation is completed. This includes early lab tests, preliminary code modules or prototypes, and modeling results meeting initial benchmarks.',
      },
      {
        level: 4,
        label: 'Subsystem Validation (Lab)',
        description:
          'Individual components or software modules are tested in lab conditions or sandbox environments. Integration into subsystems begins, showing partial system coherence.',
      },
      {
        level: 5,
        label: 'Subsystem Demonstration (Relevant)',
        description:
          'Integrated subsystems are tested in simulated or partially operational environments. For software: CI/CD pipelines may be implemented; for hardware: prototype versions are field-tested in controlled but relevant scenarios.',
      },
      {
        level: 6,
        label: 'System Prototype (Relevant)',
        description:
          'The full system is prototyped and demonstrates functionality under mission-relevant or operationally relevant conditions. Performance begins to meet defined metrics. Use and domain-specific tests are initiated.',
      },
      {
        level: 7,
        label: 'Operational Demonstration',
        description:
          'System is demonstrated in a live or mission-specific setting. Domain-specific performance (e.g., maritime, cyber, space) is confirmed. User feedback, reliability under stress, and compliance testing (security, regulatory) are documented.',
      },
      {
        level: 8,
        label: 'Limited Deployment Ready',
        description:
          'System meets all reliability, integration, and compliance criteria. All supporting documentation (e.g., training, UX, maintenance) is complete. Product is deployed in limited operational contexts. Risk monitoring and contingency planning are active.',
      },
      {
        level: 9,
        label: 'Fully Operational',
        description:
          'System performs reliably across full deployment. Scalability, sustainability, and performance under diverse conditions are confirmed. It is integrated into real-world operations with minimal intervention and meets lifecycle, environmental, and cost standards.',
      },
    ],
  },
  mrl: {
    levels: [
      {
        level: 1,
        label: 'Basic Manufacturing Implications',
        description:
          'Basic research identifies potential manufacturing implications. Early assessment of opportunities, with unfocused and exploratory investigation.',
      },
      {
        level: 2,
        label: 'Manufacturing Concepts Identified',
        description:
          'Applied research defines potential manufacturing solutions. Feasibility, risks, and material/process options start to emerge.',
      },
      {
        level: 3,
        label: 'Manufacturing Concept',
        description:
          'Manufacturing concepts are validated in lab experiments. Experimental models with limited functionality demonstrate early manufacturability.',
      },
      {
        level: 4,
        label: 'Lab Production Capability',
        description:
          'Processes and risks identified for prototype builds. Manufacturing approaches validated in lab environment, aligned with early program milestones.',
      },
      {
        level: 5,
        label: 'Prototype Components Produced',
        description:
          'Prototype components produced in production-relevant environment. Industrial base, tooling, and risk management plans established.',
      },
      {
        level: 6,
        label: 'Prototype System Production',
        description:
          'Prototype systems produced in production-relevant environment. Majority of manufacturing processes defined, supporting transition to development.',
      },
      {
        level: 7,
        label: 'Production Representative Build',
        description:
          'Manufacturing processes verified with production-representative prototypes. Supply chain readiness and production tooling initiated.',
      },
      {
        level: 8,
        label: 'Pilot Line Production',
        description:
          'Pilot line demonstrates readiness for LRIP. System design stabilized; processes, materials, and resources proven for low rate production.',
      },
      {
        level: 9,
        label: 'Low Rate Production Proven',
        description:
          'Low rate production completed; ready for full rate production. All design, supply chain, and production elements in place and verified.',
      },
      {
        level: 10,
        label: 'Full Rate Production',
        description:
          'Full rate production ongoing with lean practices. Few design changes; continuous improvement processes established and operational.',
      },
    ],
  },
};

// Maximum TRL and MRL scores derived from the settings above
export const MAX_TRL_SCORE = Math.max(...MRL_TRL_SETTINGS.trl.levels.map((level) => level.level));
export const MAX_MRL_SCORE = Math.max(...MRL_TRL_SETTINGS.mrl.levels.map((level) => level.level));

export const cmmcLevelOptions = [
  {
    label: 'Level 1',
    value: CmmcLevel.LEVEL_ONE,
  },
  {
    label: 'Level 2',
    value: CmmcLevel.LEVEL_TWO,
  },
  {
    label: 'Level 3',
    value: CmmcLevel.LEVEL_THREE,
  },
  {
    label: 'Not sure',
    value: CmmcLevel.NOT_SURE,
  },
];

export const LLM_LOG_TYPE_LABELS: Record<LlmLogType, string> = {
  [LlmLogType.Chat]: 'Chat',
  [LlmLogType.MaCapabilityInput]: 'Mission Assessment Joint Capabilities',
  [LlmLogType.MaEffectInput]: 'Mission Assessment Effect',
  [LlmLogType.MaFullAssessment]: 'Full Mission Assessment Generation',
  [LlmLogType.MaInput]: 'Mission Assessment',
  [LlmLogType.MaInterInput]: 'Mission Assessment Interoperability',
  [LlmLogType.SimilarTechnologies]: 'Similar Technologies',
  [LlmLogType.TrlAnalysis]: 'TRL Analysis',
  [LlmLogType.TrlProjection]: 'TRL Projection',
};

export const RESEARCH_ORGANIZATION_TYPE_LABELS: Record<ResearchOrganizationType, string> = {
  [ResearchOrganizationType.UNIVERSITY]: 'University/College',
  [ResearchOrganizationType.RESEARCH_CENTER]: 'Research Center',
  [ResearchOrganizationType.NATIONAL_LAB]: 'National Lab',
  [ResearchOrganizationType.FOUNDATION]: 'Foundation',
  [ResearchOrganizationType.CO_OPERATIVE_NETWORK]: 'Co-operative/Network',
  [ResearchOrganizationType.CORPORATE]: 'Corporate R&D',
  [ResearchOrganizationType.OTHER]: 'Other',
};

export const FIELDED_STATUS_LABELS: Record<FieldedStatus, string> = {
  [FieldedStatus.MILITARY_FIELDED]: 'Military Fielded',
  [FieldedStatus.COMMERCIAL_ONLY]: 'Commercial Only',
  [FieldedStatus.EMERGING_DUAL_USE]: 'Emerging Dual Use',
};

export const VERIFICATION_CONFIDENCE_LABELS: Record<VerificationConfidence, string> = {
  [VerificationConfidence.HIGH]: 'High',
  [VerificationConfidence.MEDIUM]: 'Medium',
  [VerificationConfidence.LOW]: 'Low',
};

export const CRITERIA_TYPE_OPTIONS = [
  { label: 'Organization CMMC Level', value: CriteriaType.CMMC_LEVEL },
  { label: 'Organization Country', value: CriteriaType.COUNTRY },
  { label: 'Organization Revenue Range', value: CriteriaType.REVENUE_RANGE },
  { label: 'Organization Type', value: CriteriaType.ORGANIZATION_TYPE },
  { label: 'Technology Category', value: CriteriaType.CATEGORY },
  { label: 'Technology Subcategory', value: CriteriaType.SUBCATEGORY },
  { label: 'Technology Type', value: CriteriaType.TYPE },
  { label: 'Technology TRL Question', value: CriteriaType.TRL_QUESTION },
  { label: 'Technology TRL Score', value: CriteriaType.TRL_SCORE },
  { label: 'Technology MRL Score', value: CriteriaType.MRL_SCORE },
  { label: 'Technology Uses', value: CriteriaType.USES },
  { label: 'Technology Domains', value: CriteriaType.DOMAINS },
  { label: 'Technology Research Validated', value: CriteriaType.RESEARCH_VALIDATED },
  { label: 'Technology Subsystems', value: CriteriaType.SUBSYSTEMS },
];

export const OPERATOR_OPTIONS_BY_TYPE: Record<CriteriaType, Array<{ label: string; value: CriteriaOperator }>> = {
  [CriteriaType.COUNTRY]: [
    { label: 'Is', value: CriteriaOperator.IS },
    { label: 'Is Not', value: CriteriaOperator.IS_NOT },
    { label: 'Is Any Of', value: CriteriaOperator.IS_ANY_OF },
    { label: 'Is None Of', value: CriteriaOperator.IS_NONE_OF },
  ],
  [CriteriaType.ORGANIZATION_TYPE]: [
    { label: 'Is', value: CriteriaOperator.IS },
    { label: 'Is Any Of', value: CriteriaOperator.IS_ANY_OF },
    { label: 'Is None Of', value: CriteriaOperator.IS_NONE_OF },
  ],
  [CriteriaType.REVENUE_RANGE]: [
    { label: 'Between', value: CriteriaOperator.BETWEEN },
    { label: 'Less Than', value: CriteriaOperator.LESS_THAN },
    { label: 'Greater Than', value: CriteriaOperator.GREATER_THAN },
    { label: 'Equals', value: CriteriaOperator.EQUALS },
  ],
  [CriteriaType.CMMC_LEVEL]: [
    { label: 'Is', value: CriteriaOperator.IS },
    { label: 'Is Any Of', value: CriteriaOperator.IS_ANY_OF },
    { label: 'Is None Of', value: CriteriaOperator.IS_NONE_OF },
  ],
  [CriteriaType.CATEGORY]: [
    { label: 'Is', value: CriteriaOperator.IS },
    { label: 'Is Any Of', value: CriteriaOperator.IS_ANY_OF },
  ],
  [CriteriaType.SUBCATEGORY]: [
    { label: 'Is', value: CriteriaOperator.IS },
    { label: 'Is Any Of', value: CriteriaOperator.IS_ANY_OF },
  ],
  [CriteriaType.TYPE]: [
    { label: 'Is', value: CriteriaOperator.IS },
    { label: 'Is Any Of', value: CriteriaOperator.IS_ANY_OF },
  ],
  [CriteriaType.TRL_QUESTION]: [
    { label: 'Is Any Of', value: CriteriaOperator.IS_ANY_OF },
    { label: 'Is None Of', value: CriteriaOperator.IS_NONE_OF },
  ],
  [CriteriaType.TRL_SCORE]: [
    { label: 'Range', value: CriteriaOperator.RANGE },
    { label: 'Less Than', value: CriteriaOperator.LESS_THAN },
    { label: 'Greater Than', value: CriteriaOperator.GREATER_THAN },
    { label: 'Equals', value: CriteriaOperator.EQUALS },
  ],
  [CriteriaType.MRL_SCORE]: [
    { label: 'Range', value: CriteriaOperator.RANGE },
    { label: 'Less Than', value: CriteriaOperator.LESS_THAN },
    { label: 'Greater Than', value: CriteriaOperator.GREATER_THAN },
    { label: 'Equals', value: CriteriaOperator.EQUALS },
  ],
  [CriteriaType.USES]: [
    { label: 'Includes Any Of', value: CriteriaOperator.INCLUDES_ANY_OF },
    { label: 'Includes All Of', value: CriteriaOperator.INCLUDES_ALL_OF },
  ],
  [CriteriaType.DOMAINS]: [
    { label: 'Includes Any Of', value: CriteriaOperator.INCLUDES_ANY_OF },
    { label: 'Includes All Of', value: CriteriaOperator.INCLUDES_ALL_OF },
  ],
  [CriteriaType.RESEARCH_VALIDATED]: [{ label: 'Is', value: CriteriaOperator.IS }],
  [CriteriaType.SUBSYSTEMS]: [{ label: 'Is', value: CriteriaOperator.IS }],
};

export const ANSWER_RESPONSE_PROGRESS_LABELS: Record<AnswerResponseProgress, string> = {
  [AnswerResponseProgress.IN_PROGRESS]: 'In Progress',
  [AnswerResponseProgress.NO]: 'No',
  [AnswerResponseProgress.NOT_APPLICABLE]: 'Not Applicable',
  [AnswerResponseProgress.YES]: 'Yes',
};

export const ORGANIZATION_TYPE_OPTIONS = [
  { label: COMPANY_TYPE_LABELS[CompanyType.COMMERCIAL], value: CompanyType.COMMERCIAL },
  { label: COMPANY_TYPE_LABELS[CompanyType.RESEARCH], value: CompanyType.RESEARCH },
  { label: COMPANY_TYPE_LABELS[CompanyType.RESEARCH_PROJECT], value: CompanyType.RESEARCH_PROJECT },
];

export const TECHNOLOGY_TYPE_OPTIONS = [
  { label: 'Hardware', value: TechnologyType.HARDWARE },
  { label: 'Software', value: TechnologyType.SOFTWARE },
  { label: 'Hybrid', value: TechnologyType.HYBRID },
];

// Company feature flag options - values match CompanyFeatureFlag enum from backend
export const COMPANY_FEATURE_FLAG_OPTIONS = [
  {
    description: 'Access to the Cyber Assessments tool',
    label: 'Cyber Assessments Tool',
    value: 'CYBER_ASSESSMENTS_TOOL',
  },
  {
    description: 'Access to the Insights research tool',
    label: 'Insights Tool',
    value: 'INSIGHTS_TOOL',
  },
  {
    description: 'Access to MEIA Studio',
    label: 'MEIA Studio V1',
    value: CompanyFeatureFlag.MEIA_STUDIO_V1,
  },
  {
    description: 'Access to the Research tool',
    label: 'Research Tool',
    value: 'RESEARCH_TOOL',
  },
  {
    description: 'Access to the Threads tool',
    label: 'Threads Tool',
    value: 'THREADS_TOOL',
  },
];

export const TIME_UNIT_OPTIONS = [
  { label: 'Hours', value: 'HOUR' },
  { label: 'Days', value: 'DAY' },
  { label: 'Weeks', value: 'WEEK' },
  { label: 'Months', value: 'MONTH' },
  { label: 'Years', value: 'YEAR' },
];

export const STATUS_MESSAGE_DESCRIPTIONS = {
  archived:
    'Archive this item to hide it from dropdown selections and forms. It will remain visible in existing records, but cannot be selected for new entries.',
  deleted:
    'Soft-delete this item to completely hide it from the application. It will not appear in dropdowns, forms, or admin views, but the data remains in the database for referential integrity.',
  available:
    'Restore this item to make it fully available throughout the application. It will appear in all dropdown selections, forms, and can be used for new entries.',
} as const;

export const STATUS_ERROR_MESSAGES = {
  CANNOT_DELETE_WITH_DEPENDENCIES: (itemType: string) =>
    `Cannot delete a ${itemType} that is being used. Archive it instead.`,
} as const;
